import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { en as forobaEn, fr as forobaFr, it as forobaIt } from '@foroba/ui/i18n'
import pazuruEn from '@pazuru/i18n/pazuru-en.json'
import pazuruFr from '@pazuru/i18n/pazuru-fr.json'
import pazuruIt from '@pazuru/i18n/pazuru-it.json'
import kelenEn from '@foroba-app/i18n/kelen-en.json'
import kelenFr from '@foroba-app/i18n/kelen-fr.json'
import kelenIt from '@foroba-app/i18n/kelen-it.json'
import { tsumiEn, tsumiFr, tsumiIt } from '@tsumi/locales/resources'
import { deepMerge } from './lib/deepMerge'
import { mobileEn, mobileFr, mobileIt } from './locales/mobile'

// i18next is a global singleton: initialise once here before any app code runs.
// Order matters on leaf conflicts: Foroba UI < Kelen < Yiriba < Naforo < mobile.
const savedLang =
  typeof localStorage !== 'undefined'
    ? (localStorage.getItem('foroba.language') ?? 'en')
    : 'en'

void i18n.use(initReactI18next).init({
  lng: savedLang,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  resources: {
    en: { translation: deepMerge(forobaEn, kelenEn, tsumiEn, pazuruEn, mobileEn) },
    fr: { translation: deepMerge(forobaFr, kelenFr, tsumiFr, pazuruFr, mobileFr) },
    it: { translation: deepMerge(forobaIt, kelenIt, tsumiIt, pazuruIt, mobileIt) },
  },
})

export default i18n
